import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import {CanserModel} from '../models/CanserModel';
import{ HospitalsModel} from '../models/HospitalsModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class HospitalsService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }


public getHospital(hoscode: string , comCode: string) {
  let params = new HttpParams();
    params = params.append("HosCpde", hoscode);
    params = params.append("compCode", comCode);
    const options = {
        params: params
    };
    return this.http.get<HospitalsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Hospitals/GetHospital',options);
}

public getHospitalsLookupTop(compCode: string) {
  let params = new HttpParams();
  params = params.append("compCode", compCode);
  const options = {
      params: params
  };
    return this.http.get<HospitalsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Hospitals/HospitalsLookupTop',options);
}

}
